import { useEffect, useState } from "react";
import { CircularProgress, Grid, IconButton,Typography } from "@mui/material";
import { Save as SaveIcon, Edit as EditIcon, Delete as DeleteIcon, ArrowUpward as ArrowUpwardIcon, ArrowDownward as ArrowDownwardIcon, Add as AddIcon } from "@mui/icons-material";
import { useMutation } from "react-query";
import { useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ValidationSchemaArrayVirtualTour } from "../services/SchemaValidation";
import FullScreenDialog from "components/Dialog/FullScreenDialog";
import ImageGalleryCard from "components/Card/ImageLeftCard";
import { editProductVirtualTours } from "services/api/Product";
import Add from "./Add";
import Edit from "./Edit";
import Remove from "./Remove";

export default function VirtualTour({ open, close, instance, reportAction }) {
  const [isLoading, setIsLoading] = useState(false);
  const [openAction, setOpenAction] = useState(0) // 0: close, 1: add, 2: edit, 3: delete
  const [position, setPosition] = useState(null)
  const [instanceSelected, setInstanceSelected] = useState({})
    let { /*handleSubmit: hTBP, formState: { errors: eTBP },*/ control: cTBP, setValue: svTBP, getValues } = useForm({ 
    resolver: yupResolver(ValidationSchemaArrayVirtualTour), 
    defaultValues: { 'virtual_tours': [] } 
  })
  const {fields: fTBP, append: aTBP, remove: rmvTBP, update: updTBP, move: mvTBP} = useFieldArray({ 
    name: 'virtual_tours', control: cTBP 
  })

  useEffect(() => { if (open) { svTBP('virtual_tours', instance.virtual_tours) } }, [open])

  const mutation = useMutation(editProductVirtualTours, {
    onSuccess: (data) => {
      setIsLoading(false)
      if(data.status === "error") { 
        reportAction('virtual-tour', false, { message: 'Error al editar los datos'}, false)
      } else { 
        reportAction('virtual-tour', false, { }, true) 
      }
    }
  })

  const onSubmit = () => { //console.log("onSubmit", fTBP) 
    setIsLoading(true)
    mutation.mutate({ id: instance._id, params: fTBP })
  }

  const handleClose = () => { close(); }

  const handleAddVT = (data) => { aTBP(data) }
  const handleLoadEditVT = (position, data) => {
    setPosition(position)
    setInstanceSelected(data)
  }
  const handleEditVT = (data) => { 
    let dataTemp = { ...fTBP[position], link: data.link, description: data.description }
    updTBP(position, dataTemp) 
  }
  const handleLoadRemoveVT = (position, data) => {
    setPosition(position)
    setInstanceSelected(data)
  }
  const handleRemoveVT = () => { rmvTBP(position) }
  const handlerChangePositionVT = (direction, position) => { mvTBP(position, direction === 'up' ? position - 1 : position + 1) }

  const Actions = ({ item, index, totalItems }) => ( <>
    <IconButton aria-label="edit" onClick={ () => { handleLoadEditVT(index, item); setOpenAction(2) }  }> <EditIcon color="info"/> </IconButton>
    <IconButton aria-label="delete" onClick={ () => { handleLoadRemoveVT(index, item); setOpenAction(3) } }> <DeleteIcon color='error'/> </IconButton>
    <div>
    {index !== 0 && <IconButton aria-label="up-position" onClick={ () => handlerChangePositionVT("up", index) }> <ArrowUpwardIcon /> </IconButton>}
    {index !== totalItems - 1 && <IconButton aria-label="down-position" onClick={ () => handlerChangePositionVT("down", index) }> <ArrowDownwardIcon /> </IconButton> }
    </div>
  </> )

  /* Drag and Drop */
  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return;
    var updatedList = getValues("virtual_tours");
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    svTBP('virtual_tours', updatedList)
  }
 
  return ( <>
    <FullScreenDialog open={ open } changeOpen={ handleClose } title={`Tours virtuales - ${instance.name}`} actions={ <>
      { !isLoading ? <>
        <IconButton autoFocus color="inherit" onClick={ () => setOpenAction(1) } aria-label="add"> <AddIcon /> </IconButton> 
        <IconButton autoFocus color="inherit" onClick={ onSubmit } aria-label="save"> <SaveIcon /> </IconButton>
      </> : <CircularProgress /> }
    </> }>
      <div className="admin-image-gallery one-columns">
        <div className="list-container">
          {/* <div style={{ width: "200px" }}><pre>{JSON.stringify(fTBP, undefined, 2)}</pre></div> */}
          <DragDropContext onDragEnd={handleDrop}>
            <Droppable droppableId="droppable">
              { (provided) => (
                <Grid container spacing={2} className="droppable" {...provided.droppableProps} ref={provided.innerRef}>
                { (fTBP.length > 0) ? (
                fTBP.map((item, i) => (
                  <Draggable key={item.id} draggableId={item.id} index={i}>
                    {(provided) => (
                      <Grid item xs={12} ref={provided.innerRef} {...provided.dragHandleProps} {...provided.draggableProps}>
                        <ImageGalleryCard 
                          image={item.image} 
                          description={<div> {item.link} <br /> {item.description} </div>}  
                          actions={ 
                            <Actions item={ item } index={ i } totalItems={ fTBP.length }/> 
                          }
                        />
                      </Grid>
                    )}
                  </Draggable>
                )) ) : <Grid item xs={12}> <Typography variant="inherit">No hay tours agregados</Typography> </Grid> }
                </Grid>
              ) }
            </Droppable>
          </DragDropContext>
        </div>
      </div>
    </FullScreenDialog>
    <Add open={ openAction === 1 } close={ () => setOpenAction(0) } action={ handleAddVT } />
    <Edit open={ openAction === 2 } close={ () => setOpenAction(0) } instance={ instanceSelected } action={ handleEditVT } />
    <Remove open={ openAction === 3 } close={ () => setOpenAction(0) } instance={ instanceSelected } action={ handleRemoveVT } />
  </> )
}